/**
 * AWS Challenge 服务
 * 负责获取和处理 AWS WAF 挑战令牌
 */
import * as Sentry from '@sentry/nextjs';
import { CHALLENGE_URL } from '@/app/constants';
import { AWSWafError } from './error';
import { loadScript } from './utils';

declare const AwsWafIntegration: {
  getToken: () => Promise<string>;
};

export const createChallengeService = () => {
  let loadPromise: Promise<void> | null = null;
  let isLoaded = false;

  const ensureLoaded = async (): Promise<void> => {
    if (isLoaded) {
      return;
    }

    loadPromise ??= loadScript(CHALLENGE_URL)
      .then(() => {
        isLoaded = true;
      })
      .catch((error) => {
        loadPromise = null;
        throw error;
      });

    await loadPromise;
  };

  const getChallengeToken = async (): Promise<string> => {
    try {
      await ensureLoaded();
      return AwsWafIntegration.getToken();
    } catch (error) {
      Sentry.captureException(error, {
        tags: {
          'challenge.error_type': error instanceof AWSWafError ? error.type : 'unknown',
          'challenge.operation': 'challenge',
        },
      });
      throw error;
    }
  };

  return {
    loadChallengeSuccess: () => {
      isLoaded = true;
    },
    loadChallengeError: () => {
      loadPromise = null;
      isLoaded = false;
    },
    getChallengeToken,
  };
};
